<template>
  <div class="details-card-wrapper">
    <div v-if="!ancillary">Nessun dato disponibile per questo titolo.</div>
    <info-card v-else title="Dati del titolo" :rows="rows"></info-card>
  </div>
</template>

<script>
import InfoCard from "@/components/insurance-ancillaries/details/InfoCard";
import { dash, enumText, dateOrDash, moneyOrDash } from "@/utils/details";

/*
 * Tab "Generale": i dati del titolo, in sola lettura, letti da dbRowData (la riga già
 * caricata dalla griglia) senza fetch aggiuntive.
 */
export default {
  name: "General",
  components: { InfoCard },
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ancillary() {
      return this.dbRowData?.id ? this.dbRowData : null;
    },
    rows() {
      const a = this.ancillary;
      if (!a) return [];
      return [
        { label: "Tipo titolo", value: enumText(a.code) },
        { label: "Descrizione", value: dash(a.title) },
        { label: "Stato titolo", value: enumText(a.status_ancillary) },
        { label: "Incassabile", value: enumText(a.to_collect) },
        { label: "Consolidato", value: enumText(a.consolidated) },
        { label: "Data effetto", value: dateOrDash(a.effective_at) },
        { label: "Ultimo giorno", value: dateOrDash(a.delay_until) },
        { label: "Giorni di mora", value: dash(a.delay_days) },
        { label: "Netto", value: moneyOrDash(a.net) },
        { label: "Tasse", value: moneyOrDash(a.tax) },
        { label: "Lordo", value: moneyOrDash(a.gross) },
        { label: "Di cui diritti", value: moneyOrDash(a.fee_gross) },
        { label: "Premio precedente", value: moneyOrDash(a.previous_gross_premium) },
        { label: "Upselling", value: enumText(a.upselling) },
        { label: "Registrato in compagnia", value: dateOrDash(a.registered_at) },
        { label: "Errore registrazione", value: dash(a.charge_error) },
        { label: "Note", value: dash(a.note) },
      ];
    },
  },
};
</script>
